<mat-card class="mt-1 mb-4">
    <mat-card-header>
        <div class="d-flex justify-content-start w-100 position-relative">
            <span>Berichtswesen <!-- <a *canAccess="[1,2,5,7,9]" routerLink="../../reporting/overview" routerLinkActive="active"
                    mat-button>[neu]</a> --> </span>

            <div class="d-flex justify-content-center">
                <button mat-icon-button [matMenuTriggerFor]="menuReport" aria-label="Report settings menu"
                    class="position-absolute" style="top: -21px; right: -16px; ">
                    <img src="assets/icons/settings_material.svg" height="24">
                </button>
                <mat-menu #menuReport="matMenu">
                    <button mat-menu-item (click)="openChangelogConfigOverviewModal()">
                        <img src="assets/icons/problem_24dp_FILL0_wght400_GRAD0_opsz24.svg">
                        <span class="ms-1">Berichteinstellungen einsehen</span>
                    </button>
                    <button mat-menu-item (click)="openChangelogConfigurationModal()">
                        <img src="assets/icons/person_alert_24dp_FILL0_wght400_GRAD0_opsz24.svg">
                        <span class="ms-1">Benachrichtigung anlegen</span>
                    </button>
                </mat-menu>
            </div>
        </div>
    </mat-card-header>
    <mat-card-content>
        <div class="d-flex justify-content-between position-relative">
            <div class="d-flex">
                <div>
                    <mat-form-field *ngIf="activeTab === 'Projekt-Übersicht'" class="example-form-field"
                        (click)="showTree = true;">
                        <mat-label>Suche</mat-label>
                        <input matInput type="text" [(ngModel)]="searchFilter"
                            (keyup)="filterDataSource(); showTree = true;" placeholder="Projektname...">
                        <button *ngIf="searchFilter" matSuffix mat-icon-button aria-label="Clear" (click)="resetTree()">
                            <img src="assets/icons/close_material.svg" height="24"/>
                        </button>
                    </mat-form-field>
                    <mat-form-field *ngIf="activeTab === 'Geräte-Übersicht'" class="example-form-field"
                        (click)="showTree = true;">
                        <mat-label>Suche</mat-label>
                        <input matInput type="text" [(ngModel)]="searchFilterTree"
                            (keyup)="filterDataSourceTree(); showTree = true;" placeholder="RouteStationname...">
                        <button *ngIf="searchFilterTree" matSuffix mat-icon-button aria-label="Clear"
                            (click)="resetTreeTree()">
                            <img src="assets/icons/close_material.svg" height="24"/>
                        </button>
                    </mat-form-field>
                </div>
                <div class="ms-2" *ngIf="activeTab === 'Projekt-Übersicht'">
                    <mat-form-field appearance="fill">
                        <mat-label>Projekt Status</mat-label>
                        <mat-select [(value)]="selectedStatus" (selectionChange)="filterDataSource()">
                            <mat-option value="alle">alle Projekte</mat-option>
                            <mat-option value="aktiv">aktive Projekte</mat-option>
                            <mat-option value="inaktiv">inaktive Projekte</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <div class="ms-2" *ngIf="activeTab === 'Projekt-Übersicht' || activeTab === 'Geräte-Übersicht'">
                    <mat-form-field class="example-form-field">
                        <mat-label>Zeitraum wählen</mat-label>
                        <mat-date-range-input [formGroup]="range" [rangePicker]="rangePicker">
                            <input matStartDate formControlName="start" placeholder="Startdatum" [min]="minDate"
                                [max]="maxDate">
                            <input matEndDate formControlName="end" placeholder="Enddatum" [max]="maxDate">
                        </mat-date-range-input>
                        <mat-datepicker-toggle matIconSuffix [for]="rangePicker"></mat-datepicker-toggle>
                        <mat-date-range-picker #rangePicker>
                            <mat-date-range-picker-actions>
                                <button mat-button matDateRangePickerCancel>Abbrechen</button>
                                <button mat-raised-button color="primary" matDateRangePickerApply>Ok</button>
                            </mat-date-range-picker-actions>
                        </mat-date-range-picker>
                    </mat-form-field>
                </div>
            </div>
            <div>
                <div class="ms-2">
                    <div class="d-flex justify-content-end">
                        <button *canAccess="[1]" mat-raised-button color="primary" (click)="createSchaltentscheid()"
                            class="btn btn-sm rounded-0 me-2">
                            AQ-ENGINE/SCHALTENSCHEID
                        </button>
                        <!--                         <button *canAccess="[1]" mat-raised-button color="primary" (click)="getFuellCellReport()"
                            class="btn btn-sm rounded-0 me-2">
                        FUELLCELL!!!
                        </button> -->
                        <button *ngIf="activeTab === 'Projekt-Übersicht' || activeTab === 'Geräte-Übersicht'"
                            mat-raised-button color="primary" (click)="createNewMQReport()"
                            class="btn btn-sm rounded-0 me-2">
                            Verkehrsanalysebericht
                        </button>
                        <!--                         <button (click)="logTabs()"> Log Tabs</button>
                        <button (click)="logTabsValue()"> Log mq data value</button> -->
                        <button *ngIf="activeTab === 'Projekt-Übersicht'" mat-raised-button color="primary"
                            (click)="createSWAReport()" class="btn btn-sm rounded-0 me-2">
                            SWA-Bericht
                        </button>

                        <button *ngIf="activeTab === 'Geräte-Übersicht'" mat-raised-button color="primary"
                            (click)="digitalIONamingDialog()" class="btn btn-sm rounded-0 me-2">
                            I/O-Bericht
                        </button>
                        <button *ngIf="activeTab === 'Geräte-Übersicht'" mat-raised-button color="primary"
                            (click)="createInterimsAQReport()" class="btn btn-sm rounded-0 me-2">
                            i AQ-Bericht </button>

                        <button *ngIf="activeTab === 'Geräte-Übersicht'" mat-raised-button color="primary"
                            (click)="createSWAReport()" class="btn btn-sm rounded-0 me-2">
                            SWA-Bericht
                        </button>

                        <button *ngIf="activeTab === 'Projekt-Übersicht' || activeTab === 'Geräte-Übersicht'"
                            mat-raised-button color="primary" (click)="createHeightControl()"
                            class="btn btn-sm rounded-0 me-2">
                            Höhenkontroll-Bericht
                        </button>

                        <!--  <button mat-raised-button color="primary" (click)="createHeightControlPDF()"
                            class="btn btn-sm rounded-0 me-2">
                            Höhenkontroll PDF
                        </button> -->

                        <div class="d-flex flex-column">
                            <button
                                *ngIf="activeTab === 'Geräte-Übersicht' && (activeRouteStation?.schemaInfo?.radars?.length ?? 0) > 0"
                                mat-raised-button color="primary" (click)="getMQChangelog()"
                                class="btn btn-sm rounded-0 me-2" style="width: 244px;">
                                Verkehrsdaten-Bericht
                            </button>
                            <div class="mt-2"
                                *ngIf="activeTab === 'Geräte-Übersicht' && (activeRouteStation?.schemaInfo?.radars?.length ?? 0) > 0">
                                <mat-form-field style="width: 244px;">
                                    <mat-label>Intervall</mat-label>
                                    <mat-select [(value)]="intervall">
                                        <mat-option [value]="option" *ngFor="let option of intervalls">{{ option
                                            }} min</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div
            style="border-top: 2px solid rgba(18, 18, 18, 0.509); border-bottom: 2px solid rgba(18, 18, 18, 0.252); margin-top: 8px; ">
            <div class=" d-flex justify-content-between">
                <div class="w-100">
                    <mat-tab-group mat-stretch-tabs="true" mat-align-tabs="start" [selectedIndex]="selected.value"
                        (selectedIndexChange)="selected.setValue($event)" (selectedTabChange)="tabChanged($event)">
                        <mat-tab label="Projekt-Übersicht">
                            <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
                                <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding
                                    class="border-bottom border-opacity-25 tree-node-group"
                                    [ngClass]="selectedGroup.name == returnCleanName(node.name) ? 'selectedGroup' : ''">
                                    <button mat-icon-button disabled></button>
                                    <div class="hover-class-pr-gr" style="cursor: pointer; padding: 8px;"
                                        (click)="setGroupIdByName(node)"> &#x2022;
                                        {{ returnCleanName(node.name)}}
                                    </div>
                                </mat-tree-node>
                                <mat-tree-node *matTreeNodeDef="let node;when: hasChild" matTreeNodePadding
                                    class="border-bottom border-opacity-25 tree-node-project"
                                    [ngClass]="selectedProject.name == returnCleanName(node.name) ? 'selectedProject' : ''">
                                    <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.name">
                                        <img class="mat-icon-rtl-mirror"
                                            src="{{treeControl.isExpanded(node) ? 'assets/icons/unfold_more_material.svg' : 'assets/icons/chevron_right_material.svg'}}"
                                            height="24"/>
                                    </button>
                                    <div (click)="setProjectIdByName(node)">
                                        <span class="hover-class-pr-gr" style="cursor: pointer; padding: 8px;"> {{
                                            returnCleanName(node.name)}} </span>
                                    </div>
                                </mat-tree-node>
                            </mat-tree>
                        </mat-tab>
                        <mat-tab label="Geräte-Übersicht">
                            <mat-tree [dataSource]="dataSourceRouteStations" [treeControl]="treeControl2">
                                <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding
                                    class="border-bottom border-opacity-25 tree-node-group"
                                    [ngClass]="selectedDeviceTree.name == node.name ? 'selectedGroup' : ''">
                                    <button mat-icon-button disabled></button>
                                    <div (click)="setSamIDByName(node)" style="cursor: pointer;"> <img class="me-1 img"
                                            height="18px" src="../../../assets/icons/pin-map.svg" alt="pin-map icon">
                                        {{node.name}}
                                    </div>
                                </mat-tree-node>
                            </mat-tree>
                        </mat-tab>

                        <ng-container *ngFor="let extendedChangelog of reportEngineCollection; index as i">
                            <mat-tab
                                [label]="extendedChangelog.projectName + ' | ' + correctTimezone(extendedChangelog.fromDate).split('T')[0] + '_' + extendedChangelog.toDate.split('T')[0]">
                                <div class="m-2 card rounded-0 shadow" style="min-height: 500px">
                                    <div class="d-flex justify-content-between"> <span class="fw-semibold"> {{
                                            extendedChangelog.projectName }} | {{
                                            correctTimezone(extendedChangelog.fromDate).split('T')[0]
                                            }} _ {{ extendedChangelog.toDate.split('T')[0] }}</span>
                                        <div class="d-flex">
                                            <button *ngIf="changelogs" mat-icon-button
                                                [matMenuTriggerFor]="menuDownload" aria-label="Download menu">
                                                <img src="assets/icons/download_material.svg" height="24"/>
                                            </button>
                                            <mat-menu #menuDownload="matMenu">
                                                <button mat-menu-item
                                                    (click)="downloadNewMQReport('csv', extendedChangelog)">
                                                    <img src="assets/icons/download_material.svg" height="24"/>
                                                    <span>CSV</span>
                                                </button>
                                                <button mat-menu-item
                                                    (click)="downloadNewMQReport('ascii', extendedChangelog)">
                                                    <img src="assets/icons/download_material.svg" height="24"/>
                                                    <span>ASCII</span>
                                                </button>
                                                <button mat-menu-item
                                                    (click)="downloadNewMQReport('pdf', extendedChangelog)">
                                                    <img src="assets/icons/download_material.svg" height="24"/>
                                                    <span>PDF</span>
                                                </button>
                                            </mat-menu>
                                            <button mat-icon-button (click)="removeTab(i)">
                                                <img src="assets/icons/close_material.svg" height="24"/>
                                            </button>
                                        </div>
                                    </div>
                                    <avs-changelog-engine-table
                                        [changelogs]="extendedChangelog.changelog">
                                    </avs-changelog-engine-table>
                                </div>
                            </mat-tab>
                        </ng-container>

                        <!--                         <ng-container *ngFor="let extendedChangelog of reportAQCollection; index as i">
                            <mat-tab
                                [label]="extendedChangelog.projectName + ' | ' + correctTimezone(extendedChangelog.fromDate).split('T')[0] + '_' + extendedChangelog.toDate.split('T')[0]">
                                <div class="m-2 card rounded-0 shadow" style="min-height: 500px">
                                    <div class="d-flex justify-content-between"> <span class="fw-semibold"> {{
                                            extendedChangelog.projectName }} | {{
                                            correctTimezone(extendedChangelog.fromDate).split('T')[0]
                                            }} _ {{ extendedChangelog.toDate.split('T')[0] }}</span>
                                        <div class="d-flex">
                                            <button *ngIf="changelogs" mat-icon-button
                                                [matMenuTriggerFor]="menuDownload" aria-label="Download menu">
                                                <img src="assets/icons/download_material.svg" height="24"/>
                                            </button>

                                            <mat-menu #menuDownload="matMenu">
                                                <button mat-menu-item
                                                    (click)="downloadAQEngineReport('csv', extendedChangelog)">
                                                    <img src="assets/icons/download_material.svg" height="24"/>
                                                    <span>CSV</span>
                                                </button>
                                                <button mat-menu-item
                                                    (click)="downloadAQEngineReport('ascii', extendedChangelog)">
                                                    <img src="assets/icons/download_material.svg" height="24"/>
                                                    <span>ASCII</span>
                                                </button>
                                                <button mat-menu-item
                                                    (click)="downloadAQEngineReport('pdf', extendedChangelog)">
                                                    <img src="assets/icons/download_material.svg" height="24"/>
                                                    <span>PDF</span>
                                                </button>
                                            </mat-menu>
                                            <button mat-icon-button (click)="removeAQTab(i)">
                                                <img src="assets/icons/close_material.svg" height="24"/>
                                            </button>
                                        </div>
                                    </div>

                                    <avs-changelog-aq-report
                                        [changelogs]="extendedChangelog.changelog"></avs-changelog-aq-report>

                                </div>
                            </mat-tab>
                        </ng-container>
 -->
                        <ng-container *ngFor="let extendedChangelog of reportSWACollection; index as i">
                            <mat-tab
                                [label]="extendedChangelog.projectName + ' | ' + correctTimezone(extendedChangelog.fromDate).split('T')[0] + '_' + extendedChangelog.toDate.split('T')[0]">
                                <div class="m-2 card rounded-0 shadow" style="min-height: 500px">
                                    <div class="d-flex justify-content-between"> <span class="fw-semibold"> {{
                                            extendedChangelog.projectName }} | {{
                                            correctTimezone(extendedChangelog.fromDate).split('T')[0]
                                            }} _ {{ extendedChangelog.toDate.split('T')[0] }}</span>
                                        <div class="d-flex">
                                            <button *ngIf="changelogs" mat-icon-button
                                                [matMenuTriggerFor]="menuDownload" aria-label="Download menu">
                                                <img src="assets/icons/download_material.svg" height="24"/>
                                            </button>

                                            <mat-menu #menuDownload="matMenu">
                                                <button mat-menu-item
                                                    (click)="downloadSWAReport('csv', extendedChangelog)">
                                                    <img src="assets/icons/download_material.svg" height="24"/>
                                                    <span>CSV</span>
                                                </button>
                                                <button mat-menu-item
                                                    (click)="downloadSWAReport('ascii', extendedChangelog)">
                                                    <img src="assets/icons/download_material.svg" height="24"/>
                                                    <span>ASCII</span>
                                                </button>
                                                <button mat-menu-item
                                                    (click)="downloadSWAReport('pdf', extendedChangelog)">
                                                    <img src="assets/icons/download_material.svg" height="24"/>
                                                    <span>PDF</span>
                                                </button>
                                            </mat-menu>
                                            <button mat-icon-button (click)="removeSWATab(i)">
                                                <img src="assets/icons/close_material.svg" height="24"/>
                                            </button>
                                        </div>
                                    </div>

                                    <avs-changelog-swa-report
                                        [changelogs]="extendedChangelog.changelog"></avs-changelog-swa-report>

                                </div>
                            </mat-tab>
                        </ng-container>





                        <ng-container *ngFor="let extendedChangelog of STMReportCollection; index as i">
                            <mat-tab
                                [label]="extendedChangelog.projectName + ' | ' + correctTimezone(extendedChangelog.fromDate).split('T')[0] + '_' + extendedChangelog.toDate.split('T')[0]">
                                <div class="m-2 card rounded-0 shadow" style="min-height: 500px">
                                    <div class="d-flex justify-content-between"> <span class="fw-semibold"> {{
                                            extendedChangelog.projectName }} | {{
                                            correctTimezone(extendedChangelog.fromDate).split('T')[0]
                                            }} _ {{ extendedChangelog.toDate.split('T')[0] }}</span>
                                        <div class="d-flex">
                                            <button *ngIf="changelogs" mat-icon-button
                                                [matMenuTriggerFor]="menuDownload" aria-label="Download menu">
                                                <img src="assets/icons/download_material.svg" height="24"/>
                                            </button>

                                            <mat-menu #menuDownload="matMenu">
                                                <button mat-menu-item
                                                    (click)="downloadSTMReport('csv', extendedChangelog)">
                                                    <img src="assets/icons/download_material.svg" height="24"/>
                                                    <span>CSV</span>
                                                </button>
                                                <button mat-menu-item
                                                    (click)="downloadSTMReport('ascii', extendedChangelog)">
                                                    <img src="assets/icons/download_material.svg" height="24"/>
                                                    <span>ASCII</span>
                                                </button>
                                                <button mat-menu-item
                                                    (click)="downloadSTMReport('pdf', extendedChangelog)">
                                                    <img src="assets/icons/download_material.svg" height="24"/>
                                                    <span>PDF</span>
                                                </button>
                                            </mat-menu>
                                            <button mat-icon-button (click)="removeSTMTab(i)">
                                                <!-- prop needs a fix -->
                                                <img src="assets/icons/close_material.svg" height="24"/>
                                            </button>
                                        </div>
                                    </div>
                                    <avs-changelog-stm-report [changelogs]="extendedChangelog.changelog"
                                        [digitalInput1Name]="extendedChangelog.digitalInput1Name"
                                        [digitalInput2Name]="extendedChangelog.digitalInput2Name"
                                        [digitalInput3Name]="extendedChangelog.digitalInput3Name"
                                        [digitalInput4Name]="extendedChangelog.digitalInput4Name"
                                        [digitalOutput1Name]="extendedChangelog.digitalInput1Name"></avs-changelog-stm-report>



                                </div>
                            </mat-tab>
                        </ng-container>
                        <ng-container *ngFor="let extendedChangelog of interimsAqReportCollection; index as i">
                            <mat-tab
                                [label]="extendedChangelog.projectName + ' | ' + correctTimezone(extendedChangelog.fromDate).split('T')[0] + '_' + extendedChangelog.toDate.split('T')[0]">
                                <div class="m-2 card rounded-0 shadow" style="min-height: 500px">
                                    <div class="d-flex justify-content-between"> <span class="fw-semibold"> {{
                                            extendedChangelog.projectName }} | {{
                                            correctTimezone(extendedChangelog.fromDate).split('T')[0]
                                            }} _ {{ extendedChangelog.toDate.split('T')[0] }}</span>
                                        <div class="d-flex">
                                            <button *ngIf="changelogs" mat-icon-button
                                                [matMenuTriggerFor]="menuDownload" aria-label="Download menu">
                                                <img src="assets/icons/download_material.svg" height="24"/>
                                            </button>

                                            <mat-menu #menuDownload="matMenu">
                                                <button mat-menu-item
                                                    (click)="downloadInterimsAqReport('csv', extendedChangelog)">
                                                    <img src="assets/icons/download_material.svg" height="24"/>
                                                    <span>CSV</span>
                                                </button>
                                                <button mat-menu-item
                                                    (click)="downloadInterimsAqReport('ascii', extendedChangelog)">
                                                    <img src="assets/icons/download_material.svg" height="24"/>
                                                    <span>ASCII</span>
                                                </button>
                                                <button mat-menu-item
                                                    (click)="downloadInterimsAqReport('pdf', extendedChangelog)">
                                                    <img src="assets/icons/download_material.svg" height="24"/>
                                                    <span>PDF</span>
                                                </button>
                                            </mat-menu>
                                            <button mat-icon-button (click)="removeInterimsAQTab(i)">
                                                <!-- prop needs a fix -->
                                                <img src="assets/icons/close_material.svg" height="24"/>
                                            </button>
                                        </div>
                                    </div>
                                    <avs-changelog-interims-aq-report
                                        [interimsAqReports]="extendedChangelog.changelog"></avs-changelog-interims-aq-report>



                                </div>
                            </mat-tab>
                        </ng-container>

                        <ng-container *ngFor="let extendedChangelog of reportHeightControlCollection; index as i">
                            <mat-tab
                                [label]="extendedChangelog.projectName + ' | ' + correctTimezone(extendedChangelog.fromDate).split('T')[0] + '_' + extendedChangelog.toDate.split('T')[0]">
                                <div class="m-2 card rounded-0 shadow" style="min-height: 500px">
                                    <div class="d-flex justify-content-between"> <span class="fw-semibold"> {{
                                            extendedChangelog.projectName }} | {{
                                            correctTimezone(extendedChangelog.fromDate).split('T')[0]
                                            }} _ {{ extendedChangelog.toDate.split('T')[0] }}</span>
                                        <div class="d-flex">
                                            <button *ngIf="changelogs" mat-icon-button
                                                [matMenuTriggerFor]="menuDownload" aria-label="Download menu">
                                                <img src="assets/icons/download_material.svg" height="24"/>
                                            </button>

                                            <mat-menu #menuDownload="matMenu">
                                                <button
                                                    (click)="downloadHeightControlReport('csv', extendedChangelog.filter)"
                                                    mat-menu-item>
                                                    <img src="assets/icons/download_material.svg" height="24"/>
                                                    <span>CSV</span>
                                                </button>
                                                <button mat-menu-item
                                                    (click)="downloadHeightControlReport('ascii', extendedChangelog.filter)">
                                                    <img src="assets/icons/download_material.svg" height="24"/>
                                                    <span>ASCII</span>
                                                </button>
                                                <button mat-menu-item
                                                    (click)="downloadHeightControlReport('pdf', extendedChangelog.filter)">
                                                    <img src="assets/icons/download_material.svg" height="24"/>
                                                    <span>PDF</span>
                                                </button>
                                            </mat-menu>
                                            <button mat-icon-button (click)="removeHeightControlTab(i)">
                                                <!-- prop needs a fix -->
                                                <img src="assets/icons/close_material.svg" height="24"/>
                                            </button>
                                        </div>
                                    </div>
                                    <avs-changelog-height-control-report
                                        [changelogs]="extendedChangelog.changelog"></avs-changelog-height-control-report>
                                </div>
                            </mat-tab>
                        </ng-container>



                        <ng-container *ngFor="let extendedChangelog of reportMQCollection; index as i">
                            <!-- nur einmal anlegen -->
                            <mat-tab
                                [label]="extendedChangelog.projectName + ' | ' + correctTimezone(extendedChangelog.fromDate).split('T')[0] + '_' + extendedChangelog.toDate.split('T')[0]">
                                <div class="m-2 card rounded-0 shadow" style="min-height: 500px">
                                    <div class="d-flex justify-content-between"> <span class="fw-semibold"> {{
                                            extendedChangelog.projectName }} | {{
                                            correctTimezone(extendedChangelog.fromDate).split('T')[0]
                                            }} _ {{ extendedChangelog.toDate.split('T')[0] }}</span>

                                        <div class="d-flex">
                                            <button mat-icon-button (click)="removeMQTab(i)">
                                                <img src="assets/icons/close_material.svg" height="24"/>
                                            </button>
                                        </div>
                                    </div>
                                    <div *ngFor=" let log of extendedChangelog.changelog; index as ic">
                                        <mat-card appearance="outlined" class="m-4">
                                            <mat-card-header> {{log.lane}}</mat-card-header>


                                            <avs-changelog-mq-graph [mqReports]="log.changeLogMqReport"
                                                [samId]="extendedChangelog.samId" [index]="log.channel"
                                                [fromDate]="extendedChangelog.fromDate"
                                                [toDate]="extendedChangelog.toDate"
                                                (genereatedJPGURL)="recievedJPGURL($event, extendedChangelog.samId, ic, extendedChangelog.fromDate, extendedChangelog.toDate)"></avs-changelog-mq-graph>
                                            <div>
                                                <div *ngFor=" let pdf of pdfURLObjects">
                                                    <ng-container
                                                        *ngIf="pdf.samId === extendedChangelog.samId && pdf.channel === ic">
                                                        <div class="d-flex justify-content-end">
                                                            <a [href]="pdf.pdfUrl" target="_blank"
                                                                class="btn btn-sm btn-primary rounded-0">PDF</a>
                                                        </div>
                                                    </ng-container>
                                                </div>
                                                <avs-changelog-mq-report [mqReports]="log.changeLogMqReport"
                                                    [samId]="extendedChangelog.samId" [index]="log.channel"
                                                    style="height: 500px" [fromDate]="extendedChangelog.fromDate"
                                                    [toDate]="extendedChangelog.toDate"
                                                    (generatedPDFURL)="recievedPDFURL($event, extendedChangelog.samId, ic, extendedChangelog.fromDate, extendedChangelog.toDate)"
                                                    [projectId]="extendedChangelog.projectId!"
                                                    [jpgUrl]="filterURLs(extendedChangelog.samId, ic, extendedChangelog.fromDate, extendedChangelog.toDate)"></avs-changelog-mq-report>
                                            </div>
                                        </mat-card>
                                    </div>
                                </div>
                            </mat-tab>
                        </ng-container>

                        <ng-container *ngFor="let extendedChangelog of aqEngineReportCollection; index as i">
                            <mat-tab
                                [label]="extendedChangelog.projectName + ' | ' + correctTimezone(extendedChangelog.fromDate).split('T')[0] + '_' + extendedChangelog.toDate.split('T')[0]">
                                <div class="m-2 card rounded-0 shadow" style="min-height: 500px">
                                    <div class="d-flex justify-content-between"> <span class="fw-semibold"> {{
                                            extendedChangelog.projectName }} | {{
                                            correctTimezone(extendedChangelog.fromDate).split('T')[0]
                                            }} _ {{ extendedChangelog.toDate.split('T')[0] }}</span>
                                        <div class="d-flex">
                                            <!--  <button *ngIf="changelogs" mat-icon-button
                                                [matMenuTriggerFor]="menuDownload" aria-label="Download menu">
                                                <img src="assets/icons/download_material.svg" height="24"/>
                                            </button>

                                            <mat-menu #menuDownload="matMenu">
                                                <button mat-menu-item
                                                    (click)="downloadSTMReport('csv', extendedChangelog)">
                                                    <img src="assets/icons/download_material.svg" height="24"/>
                                                    <span>CSV</span>
                                                </button>
                                                <button mat-menu-item
                                                    (click)="downloadSTMReport('ascii', extendedChangelog)">
                                                    <img src="assets/icons/download_material.svg" height="24"/>
                                                    <span>ASCII</span>
                                                </button>
                                                <button mat-menu-item
                                                    (click)="downloadSTMReport('pdf', extendedChangelog)">
                                                    <img src="assets/icons/download_material.svg" height="24"/>
                                                    <span>PDF</span>
                                                </button>
                                            </mat-menu> -->
                                            <button mat-icon-button (click)="removeInterimsAQTab(i)">
                                                <!-- prop needs a fix -->
                                                <img src="assets/icons/close_material.svg" height="24"/>
                                            </button>
                                        </div>
                                    </div>
                                    <avs-changelog-aq-engine
                                        [changelogs]="extendedChangelog.changelog"></avs-changelog-aq-engine>



                                </div>
                            </mat-tab>
                        </ng-container>
                    </mat-tab-group>
                </div>
            </div>
        </div>
    </mat-card-content>
</mat-card>

<div *ngIf="isLoading" class="overlay">
    <mat-spinner></mat-spinner>
    <div class="d-flex flex-column justify-content-center"
        style="position: absolute; top: 70%; left: 50%; transform: translate(-50%, -50%); z-index: 1001; background-color: rgba(255, 255, 255, 0.708); padding: 16px;">
        <h5> Der Ladevorgang könnte einen Moment in Anspruch nehmen, bitte warten...</h5>
        <div class="d-flex justify-content-center">
            <button class="btn btn-sm btn-danger rounded-0 mt-2" (click)="isLoading = false">
                Abbrechen
            </button>
        </div>
    </div>
</div>